const NS = 'SiteHeaderBottomWidget';
const CLS = 'siteHeaderBottomWidget';

import { operatingSystemDetector } from '../../../../global/js/wool/operatingSystemDetector';

export class SiteHeaderBottomWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.operatingSystemDetector = operatingSystemDetector;
		this.operatingSystem = this.operatingSystemDetector.getOS();

		// Font size objects set in order of toggling
		this.fontSizeObjects = [
			{
				key: 'normal',
				value: 15
			},
			{
				key: 'large',
				value: 16
			},
			{
				key: 'xlarge',
				value: 17
			},
			{
				key: 'small',
				value: 14
			}
		];
		this.activeFontSizeObject = this.getGlobalFontSizeObject();

		this.$siteHeaderBottomMenuWidget = this.$element.find(`.siteHeaderBottomMenuWidget`);
		this.$siteHeaderBottomSearchBarWidget = this.$element.find(`.siteHeaderBottomSearchBarWidget`);
		this.$siteHeaderWidget = this.$element.parent(`.siteHeaderWidget`);
		$(document.body).append(this.$siteHeaderBottomMenuWidget);
		$(document.body).append(this.$siteHeaderBottomSearchBarWidget);

		this.$togglerButton = this.$element.find(`.${CLS}-btn--toggler`);
		this.$togglerButton.on('click', () => {
			if(!this.$togglerButton.hasClass('active')) {
				destroyItems({
					searchBar: true
				});

				this.$siteHeaderBottomMenuWidget.trigger('siteHeaderBottomMenuWidget.open', {
					siteHeaderBottomWidget: this.$element
				});

				this.$togglerButton.addClass('active');

				this.$siteHeaderWidget.addClass(`siteHeaderWidget--activeElement`);
			}
			else {
				destroyItems({
					bottomMenu: true,
					searchBar: true
				});
			}
		});

		this.$searchBarButton = this.$element.find(`.${CLS}-btn--search`);
		this.$searchBarButton.on('click', () => {
			if(!this.$searchBarButton.hasClass('active')) {
				destroyItems({
					bottomMenu: true
				});

				this.$siteHeaderBottomSearchBarWidget.trigger('siteHeaderBottomSearchBarWidget.open', {
					siteHeaderBottomWidget: this.$element
				});

				this.$searchBarButton.addClass('active');
				this.$siteHeaderWidget.addClass(`siteHeaderWidget--activeElement`);
			}
			else {
				destroyItems({
					bottomMenu: true,
					searchBar: true
				});
			}
		});

		let destroyItems = (include) => {

			if(include.searchBar) {
				this.$siteHeaderBottomSearchBarWidget.trigger('siteHeaderBottomSearchBarWidget.close', {});
				this.$searchBarButton.removeClass('active');
			}

			if(include.bottomMenu) {
				this.$siteHeaderBottomMenuWidget.trigger('siteHeaderBottomMenuWidget.close', {});
				this.$togglerButton.removeClass('active');
			}

			this.$siteHeaderWidget.removeClass(`siteHeaderWidget--activeElement`);
		};

		this.$adjustFontSizeButton = this.$element.find(`.${CLS}-btn--fontAdjust`);
		this.$adjustFontSizeButton.on('click', () => {
			this.adjustFontSize();
		});

		this.$element.on(`${CLS}.menuWidgets.close`, () => {
			destroyItems({
				bottomMenu: true,
				searchBar: true
			});
		});

		// Conceal the dropdown and the searchBar
		$(window).on('resize', _.throttle(() => {
			// Make exception for android
			if(!this.operatingSystemDetector.OperatingSystemItems.Android) {
				destroyItems({
					bottomMenu: true,
					searchBar: true
				});
			}
		}, 50));

		$(window).on('orientationchange', () => {
			destroyItems({
				bottomMenu: true,
				searchBar: true
			});
		});

		this.removeClonedWidgets();
	}

	removeClonedWidgets() {
		// Remove cloned instances
		if($('.siteHeaderBottomMenuWidget').length > 1) {
			$('.siteHeaderBottomMenuWidget').last().remove();
		}
		if($('.siteHeaderBottomSearchBarWidget').length > 1) {
			$('.siteHeaderBottomSearcgBarWidget').last().remove();
		}
	}

	getGlobalFontSizeObject() {
		let globalFontObject = JSON.parse(localStorage.getItem('awi.wool.globalFontObject'));

		if(!_.isNil(globalFontObject) && globalFontObject.key) {
			for(let i = 0; i < this.fontSizeObjects.length; i++) {
				let fontSizeObject = this.fontSizeObjects[i];

				if(globalFontObject.key === fontSizeObject.key) {
					return fontSizeObject;
				}
			}
		}
		globalFontObject = this.fontSizeObjects[0];
		this.setGlobalFontSize(globalFontObject);
		return globalFontObject;
	}

	setGlobalFontSize(fontSizeObject) {
		localStorage.setItem('awi.wool.globalFontSize', JSON.stringify(fontSizeObject));
	}

	adjustFontSize() {
		if(this.activeFontSizeObject) {
			let index = this.fontSizeObjects.indexOf(this.activeFontSizeObject);
			if(index >= 0 && index < this.fontSizeObjects.length - 1) {
				this.activeFontSizeObject = this.fontSizeObjects[index + 1];
			}
			else if(index === this.fontSizeObjects.length - 1) {
				this.activeFontSizeObject = this.fontSizeObjects[0];
			}

			this.setGlobalFontSize(this.activeFontSizeObject);
			if(this.activeFontSizeObject.value) {
				$('html').css({ fontSize: this.activeFontSizeObject.value });
			}
			else {
				console.error(`${NS}::Error`, 'activeFontSizeObject.value is not defined');
			}
		}
		else {
			console.error(`${NS}::Error`, 'activeFontSizeObject is not defined');
		}
	}
}
